import React from 'react'
import EmbedNode from '../EmbedNode'

export default function GoogleSlidesNode({id,data,selected,...props}) {
    return (
        <EmbedNode domain='slides.google.com' className='' text='Google Slides Link' transformUrl={(url) => (url.includes('?')&&!url.includes('embedded=true'))? url+'&embedded=true':url+'?embedded=true'} id={id} data={data} selected={selected} {...props} />
    )
}
